<template>
  <div class="notice" :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div class="notice-left">
      <span class="iconfont icon-tongzhi color-1">:</span>
      <span class="notice-left-span"></span>
    </div>
    <el-carousel
      height="20px"
      direction="vertical"
      class="notice-carousel"
      :autoplay="autoplay"
      :interval="interval"
    >
      <el-carousel-item v-for="(item, index) in noticeList" :key="index">
        <div
          class="notice-span"
          @click="
            dialogVisible = true;
            info = item;
            getNoticeList(item);
          "
        >
          {{ item.title }}
        </div>
      </el-carousel-item>
    </el-carousel>

    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      center
    >
      <div class="content-box">
        <div class="content-box-l scrollbar-definition">
          <!-- <div class="content-box-l-title">{{ info.title }}</div> -->
          <!-- <div class="content-box-l-t1">
            <span>发布日期：{{ info.createTime }}</span>
            <span> 来源：{{ info.source }}</span>
          </div> -->
          <div style="padding: 0 10px" v-html="info.content"></div>
        </div>
        <!-- <div class="content-box-r">
          <el-table :data="tableData" style="width: 100%" @row-click="rowClick">
            <el-table-column prop="title" label="标题" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="发布时间"
              width="100"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
          <div class="content-box-r-page">
            <el-pagination
              layout="prev, pager, next"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :page-size="search.size"
              :current-page="search.current"
            >
            </el-pagination>
          </div>
        </div> -->
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>
  </div>
</template>
<script>
import {
  transferAnnouncement,
  getNoticePage,
  getIndexAnnouncement,
  getIndexAnnouncementDetails,
} from "@/api/setting/investment";

export default {
  data() {
    return {
      screenIndexWidth: null,
      is_open: false,
      list: [
        { is_open: true },
        { is_open: false },
        { is_open: false },
        { is_open: false },
        { is_open: false },
        { is_open: false },
      ],
      info: {},
      dialogVisible: false,
      noticeList: [],
      imgUrl: "",
      tableData: [],
      search: { type: 2, classify: "09", current: 1, size: 10 },
      total: 0,
      autoplay: true,
      interval: 3000,
    };
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
    this.getNotice();
  },
  methods: {
    rowClick(info) {
      this.info = info;
    },
    handleSizeChange(val) {
      this.search.size = val;
      this.getNoticeList();
    },
    handleCurrentChange(val) {
      this.search.current = val;
      this.getNoticeList();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    goUrl() {
      this.$router.push({
        path: "/industry/list",
        query: { activeName: "09" },
      });
    },
    goDetail(item) {
      this.$router.push({
        name: "rtfPreview",
        params: item,
      });
    },
    isOpen(index) {
      this.noticeList[index].is_open = !this.noticeList[index].is_open;
    },
    getNoticeList(item) {
      console.log(item);
      let obj = {
        code: item.parcelCode,
      };
      if (item.type == 1) {
        getIndexAnnouncementDetails(obj).then((res) => {
          if (res.data.success) {
            this.info = res.data.data;
          }
        });
      } else {
        transferAnnouncement(item.parcelCode).then((res) => {
          if (res.data.success) {
            this.info = res.data.data;
          }
        });
      }

      // getNoticePage(this.search).then((res) => {
      //   if (res.data.success) {
      //     this.tableData = res.data.data.records;
      //     this.info=res.data.data.records[0]
      //   }
      // });
    },
    //公告列表
    getNotice() {
      getIndexAnnouncement().then((res) => {
        if (res.data.success) {
          this.noticeList = res.data.data;
        }
      });
    },
  },
};
</script>
<style scoped>
::v-deep .el-dialog__title {
  color: #0f61b5;
  font-weight: bold;
}
.content-box {
  display: flex;
}
.content-box-l {
  width: 100%;
  max-height: 600px;
  overflow: auto;
}
.content-box-l-title {
  padding: 0 10px;
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
}
.content-box-t {
  font-size: 0.95rem;
  font-weight: bold;
  color: #000;
  margin-bottom: 10px;
}
.content-box-l-t1 {
  text-align: center;
  font-size: 0.75rem;
  margin-top: 10px;
  color: #919191;
}
.content-box-r {
  width: 38%;
  padding: 0 10px;
}
.content-box-r-page {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.notice {
  width: 100%;
  height: 20px;
  line-height: 20px;
  display: flex;
}
.color-1 {
  color: rgb(44, 127, 250);
  font-weight: 600;
}
.notice-span {
  font-size: 0.8rem;
  color: #686767;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.notice-left {
  width: 28px;
  font-size: 0.85rem;
}
.notice-left-span {
  padding-left: 5px;
  color: #000;
}
.notice-carousel {
  width: calc(100% - 65px);
}
.carousel-box {
  width: 40%;
  height: 200px;
}

.carousel-img {
  width: 100%;
  height: 200px;
}
/* .carousel-box > img {
  width: 40%;
  height: 100%;
} */
.notice-box {
  padding-left: 20px;
  width: calc(60% - 40px);
  height: 100%;
  overflow: hidden;
}
.notice-box-top {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(197, 197, 197);
  padding-bottom: 10px;
}
.notice-box-top-l {
  font-size: 1rem;
  color: rgb(173, 4, 4);
  font-weight: 600;
  display: flex;
  align-items: center;
}
.notice-box-top-l > span {
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgb(173, 4, 4);
  margin-right: 6px;
}
.notice-box-top-r {
  font-size: 0.75rem;
  color: rgb(165, 164, 164);
  cursor: pointer;
}
.notice-box-content {
  height: calc(100% - 32px);
  overflow-y: auto;
  overflow-x: hidden;
}
.notice-box-content-li {
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
  color: #302f2f;
}
.notice-box-content-li-l {
  width: 75%;
  display: flex;
}
.notice-box-content-li-l > span {
  width: calc(100% - 30px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.li-icon {
  color: rgb(9, 174, 240);
  font-size: 1.25rem;

  display: block;
  cursor: pointer;
}

.li-off {
  transition: all 0.3s ease-in-out;
  transform: rotate(0deg);
}
.li-open {
  transition: all 0.3s ease-in-out;
  transform: rotate(90deg);
}
.notice-box-content-li-r {
  width: 25%;
  text-align: right;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.notice-box-content-open {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-size: 0.75rem;
  padding: 2px;
  line-height: 21px;
  color: rgb(83, 85, 87);
  border-bottom: 1px solid #cfcfcf;
}
</style>